// src/App.js
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Projects from './pages/Projects';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import TermsAndConditions from './pages/Terms';
import PrivacyPolicy from './pages/Privacy';

function App() {
  return (
    <Router>
      <div className="font-sans bg-gray-50 text-gray-800 antialiased">
        <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/case-studies" element={<Projects />} />
            <Route path="/terms" element={<TermsAndConditions />} />
            <Route path="*" element={<Home />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
          </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;